export default {
      id: "send-usage",
      viewBox: "0 0 15 12",
      url: "assets/" + "sprite.svg#send-usage",
      toString: function () {
        return this.url;
      }
    }